/**
 * MobileTeamLogo — the shared square team-picture tile (logo where present, else
 * gold-tinted initials). Mirrors the desktop TeamLogo.js pattern (img + onError →
 * reveal the hidden initial-fallback sibling). Square with a small radius. Used by
 * the Trade Center team list/headers, League Home message avatars, etc.
 * `size` controls the box (30 default; smaller inline avatars pass e.g. 28/18).
 */
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';

const C = dynastyTheme.tokens.colors;

const MobileTeamLogo = ({ name, logoUrl, size = 30 }) => {
  const abbr = (name || '?').replace(/[^A-Za-z]/g, '').slice(0, 2).toUpperCase() || '?';
  const fontSize = size <= 20 ? 8 : 10;
  const initialStyle = {
    width: size, height: size, borderRadius: 6, flexShrink: 0, alignItems: 'center',
    justifyContent: 'center', fontSize, fontWeight: 800, color: C.neutral[950],
    background: `linear-gradient(135deg, ${C.primary}, ${C.gold.deep})`,
  };
  if (!logoUrl) return <div style={{ ...initialStyle, display: 'flex' }}>{abbr}</div>;
  return (
    <>
      <img
        src={logoUrl} alt=""
        style={{ width: size, height: size, borderRadius: 6, objectFit: 'cover', flexShrink: 0, border: `1px solid ${C.border}` }}
        onError={(e) => { e.target.style.display = 'none'; if (e.target.nextElementSibling) e.target.nextElementSibling.style.display = 'flex'; }}
      />
      <div style={{ ...initialStyle, display: 'none' }}>{abbr}</div>
    </>
  );
};

export default MobileTeamLogo;
